import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=9084a0ca&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=9084a0ca&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9084a0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9084a0ca')) {
      api.createRecord('9084a0ca', component.options)
    } else {
      api.reload('9084a0ca', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=9084a0ca&scoped=true&", function () {
      api.rerender('9084a0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notification.vue"
export default component.exports